module.exports = __webpack_public_path__ + "static/media/consumer-power-mobile.4294747d.jpg";